import { AppSidebar } from "@/components/app-sidebar";
import { CustomerReferral, CustomerReferralHandle } from "@/components/customer-referral";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useState, useRef } from "react";

export default function CustomerReferralPage() {
  const [activeTab, setActiveTab] = useState("forms");
  const customerReferralRef = useRef<CustomerReferralHandle>(null);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <AppSidebar />
      <main className="flex-1 overflow-y-auto">
        <div className="py-4 px-6 border-b">
          <div className="flex flex-wrap items-center justify-between mb-4 gap-2">
            <div>
              <h1 className="text-2xl font-bold">Kunden Werben</h1>
              <p className="text-sm text-muted-foreground">Erstellen und verwalten Sie Formulare für Kundenempfehlungen</p>
            </div>
            {activeTab === "forms" && (
              <div className="flex items-center gap-3">
                <Button 
                  variant="default" 
                  size="sm"
                  onClick={() => customerReferralRef.current?.handleCreateForm()}
                  className="flex gap-2 items-center"
                >
                  <Plus size={16} />
                  <span>Neues Formular</span>
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="p-6">
          <CustomerReferral ref={customerReferralRef} onTabChange={setActiveTab} />
        </div>
      </main>
    </div>
  );
} 
